// extracted by mini-css-extract-plugin
export default {"body":"Hisotry_body__iwfWe","footer":"Hisotry_footer__jw8jV","myButton":"Hisotry_myButton__4FsPS","mod":"Hisotry_mod__yRh0r"};